export default __webpack_public_path__ + "tutorial-3@3x.067e5a9b.png";